import { ReactNode } from 'react';

import styles from '@components/labels/Tag.module.css';
import TagIcon from '@components/typography/icons/TagIcon';
import TagText from '@components/typography/TagText';
import { IconName } from '@utils/iconUtils';

export type Color =
  | 'accentEggplant'
  | 'accentSky'
  | 'error500'
  | 'neutral50'
  | 'neutral100'
  | 'neutral700'
  | 'primary50'
  | 'primary300'
  | 'primary500'
  | 'primary700'
  | 'secondary500'
  | 'secondary700'
  | 'success500'
  | 'shadesBlack'
  | 'shadesWhite'
  | 'tagGreen'
  | 'tagOrange';

export type TagProps = {
  children?: ReactNode;
  color: Color;
  icon?: IconName;
  size?: 'large';
  spacing?: boolean;
  text?: string;
  textColor?: Color;
};

const Tag = ({ children, color, icon, size, spacing = false, text, textColor }: TagProps) => {
  const colorForText = textColor ? textColor : color === 'neutral50' ? 'shadesBlack' : 'shadesWhite';

  return (
    <div
      className={`${styles.tag} ${size === 'large' ? styles.largeTag : ''} ${styles[color]} ${
        spacing ? styles.spacing : ''
      } ${icon ? styles.withIcon : ''}`}
    >
      {icon && (
        <span className={styles.icon}>
          <TagIcon color={colorForText} icon={icon} />
        </span>
      )}
      <TagText color={colorForText}>{children ?? text}</TagText>
    </div>
  );
};

export default Tag;
